import { render, staticRenderFns } from "./modal-edit-review.vue?vue&type=template&id=334ef05e&scoped=true"
import script from "./modal-edit-review.vue?vue&type=script&lang=js"
export * from "./modal-edit-review.vue?vue&type=script&lang=js"
import style0 from "./modal-edit-review.vue?vue&type=style&index=0&id=334ef05e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334ef05e",
  null
  
)

export default component.exports